'use client';

import * as React from 'react';

export interface IRequestContext {
  origin: string;
}

export const RequestContext = React.createContext<IRequestContext>({
  origin: '',
});

export const useOrigin = (): string => {
  const context = React.useContext(RequestContext);
  if (!context) {
    throw new Error('useOrigin must be used within a RequestProvider');
  }
  return context.origin;
};

export const useIsInternal = (): boolean => {
  const context = React.useContext(RequestContext);
  if (!context) {
    throw new Error('useIsInternal must be used within a RequestProvider');
  }
  return context.origin.includes('internal');
};

export const RequestProvider = ({ origin, children }: { origin: string; children: React.ReactNode }) => {
  return <RequestContext.Provider value={{ origin }}>{children}</RequestContext.Provider>;
};
